if (!customElements.get("td-pdp-side-drawer")) {
  class TdPdpSideDrawer extends HTMLElement {
    constructor() {
      super();
      this.titleButtons = this.querySelectorAll("[data-side-drawer]");
      this.body = document.querySelector("body");
      this.overlayClass = "td-sd__overlay";
    }

    connectedCallback() {
      this.initSideDrawer();
    }

    initSideDrawer() {
      this.titleButtons.forEach((title) => {
        title.addEventListener("click", (event) => {
          const drawerNumber = title.dataset.sideDrawer;
          const contentWrapper = this.querySelector(
            `[data-side-drawer-${drawerNumber}-wrapper]`
          );

          this.querySelectorAll(".td-sd__content-wrapper--active").forEach((openWrapper) => {
            if (openWrapper !== contentWrapper) {
              openWrapper.classList.remove("td-sd__content-wrapper--active");
            }
          });

          if (contentWrapper) {
            const isActive = contentWrapper.classList.contains("td-sd__content-wrapper--active");

            if (isActive) {
              this.closeDrawer(contentWrapper);
            } else {
              this.openDrawer(contentWrapper);
            }
          }
        });
      });

      const closeButtons = this.querySelectorAll(".td-sd__close");
      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener("click", (event) => {
          const contentWrapper = closeButton.closest(".td-sd__content-wrapper");
          if (contentWrapper) {
            this.closeDrawer(contentWrapper);
          }
          event.stopPropagation();
        });
      });

      this.body.addEventListener("click", (event) => {
        if (event.target === this.body && this.body.classList.contains(this.overlayClass)) {
          const contentWrapper = this.querySelector(".td-sd__content-wrapper--active");
          
          if (contentWrapper) {
            this.closeDrawer(contentWrapper);
          }
        }
      });

      // External triggers: use delegation so triggers added later (e.g. bold links from product selector) work
      const sectionId = this.getAttribute("data-section-id");
      const instanceId = this.getAttribute("data-drawer-instance");
      if (!sectionId && !instanceId) return;

      const bindDelegatedTrigger = () => {
        if (document.__tdSideDrawerTriggerDelegation) return;
        document.__tdSideDrawerTriggerDelegation = true;
        document.addEventListener("click", (e) => {
          const trigger = e.target.closest("[data-trigger-side-drawer]");
          if (!trigger) return;
          const triggerInstance = trigger.getAttribute("data-drawer-instance");
          const triggerSection = trigger.getAttribute("data-drawer-section-id");
          const drawer = triggerInstance
            ? document.querySelector(`td-pdp-side-drawer[data-drawer-instance="${triggerInstance}"]`)
            : document.querySelector(`td-pdp-side-drawer[data-section-id="${triggerSection}"]`);
          if (!drawer) return;
          const drawerNumber = trigger.getAttribute("data-trigger-side-drawer");
          const contentWrapper = drawer.querySelector(
            `[data-side-drawer-${drawerNumber}-wrapper]`
          );
          if (contentWrapper) {
            e.preventDefault();
            drawer.openDrawer(contentWrapper);
          }
        });
      };
      bindDelegatedTrigger();
      
    }

    openDrawer(contentWrapper) {
      if (this.body) {
        this.body.classList.add(this.overlayClass);
      }

      contentWrapper.classList.add("td-sd__content-wrapper--active");
    }

    closeDrawer(contentWrapper) {
      contentWrapper.classList.remove("td-sd__content-wrapper--active");

      if (!this.querySelector(".td-sd__content-wrapper--active") && this.body) {
        this.body.classList.remove(this.overlayClass);
      }
    }

    closeAllDrawers() {
      const hadActiveDrawer = Boolean(this.querySelector(".td-sd__content-wrapper--active"));

      this.querySelectorAll(".td-sd__content-wrapper--active").forEach((openWrapper) => {
        openWrapper.classList.remove("td-sd__content-wrapper--active");
      });

      if (this.body) {
        this.body.classList.remove(this.overlayClass);
        if (hadActiveDrawer) {
        }
      }
    }
  }

  customElements.define("td-pdp-side-drawer", TdPdpSideDrawer);
}
